<template>
  <qx-card-form title="调度方式">
    <qx-custom-form :noSubBtn="true"
                    ref="baseForm"
                    :formData="baseForm"
                    labelWidth="120px">
      <section slot="dispatchMode"
               slot-scope="prop">
        <!-- 指派车辆 -->
        <AssignVehicle ref="assignVehicle"
                       @queryMemberBenefits="queryMemberBenefits"
                       :modeOtherData="otherFormData"
                       :isNeedBill="otherFormData.isNeedBill"
                       :showComponent="isAppointWay(prop.form.appointWay, '3')" />
        <!-- 指派员工 -->
        <AssignStaff ref="assignStaff"
                     @setBelongForm="setBelongForm"
                     :modeOtherData="otherFormData"
                     :isNeedBill="otherFormData.isNeedBill"
                     :showComponent="isAppointWay(prop.form.appointWay, '4')" />
        <!-- 指派车队 -->
        <AssignFleet ref="assignFleet"
                     :modeOtherData="otherFormData"
                     :isNeedBill="otherFormData.isNeedBill"
                     :showComponent="isAppointWay(prop.form.appointWay, '5')" />
      </section>
    </qx-custom-form>
    <button @click="getDataTest"
            class="test-btn">
      测试提交参数1111111111111111111111
    </button>
  </qx-card-form>
</template>
<script>
import AssignVehicle from './appointWay/assignVehicle/assignVehicle';
import AssignStaff from './appointWay/assignStaff/assignStaff';
import AssignFleet from './appointWay/assignFleet/assignFleet';
import {
  isExist,
  adjustData,
} from '@qx/utils/index';
import { renamePostParams, deleteUnwantParams } from './setParams';
export default {
  components: {
    AssignVehicle,
    AssignStaff,
    AssignFleet,
  },
  data () {
    return {
      parentComponent: {},
      defaultBillData: {},
      isNeedBillOptionsBackup: [],
      otherFormData: {
        orderId: 0,
        orderState: 0,
        isNeedBill: '0',

        oldUpdateType: null,
        updateType: null,
        dispatch: '0',

        // 油相关
        oilInfo: {},
        // 线路信息
        lineInfo: {},
        // 发车时间
        dependTimeFromBaseForm: '',
      },
      baseForm: {
        appointWayOptions: [],
        // isNeedBillOptions: [],
        paymentWayOptions: [],
        inline: true,
        form: [
          {
            label: '调度方式',
            value: 'appointWay',
            type: 'radio',
            default: '3',
            disabled: false,
            onChange: (appointWay) => {
              this.appointWayChange({
                appointWay,
                fromUserChange: true,
              });
            },
          },
          {
            value: 'dispatchMode',
            allCustom: true,
          },
        ],
        rules: {
          appointWay: [
            { required: true, message: '请选择调度方式', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    getParentComponent (_this) {
      this.parentComponent = _this;
    },
    setList (options, otherData, isEnum) {
      this.baseForm.appointWayOptions = options[0];
      this.baseForm.paymentWayOptions = options[1];
      this.defaultBillData = otherData.defaultBillData;
      this.$refs.assignVehicle.setList(options[1], otherData, isEnum);
    },
    setDependTime (data) {
      this.otherFormData.dependTimeFromBaseForm = data;
      this.$refs.assignVehicle.setDependTime(data);
    },
    setData (data) {
      // 如果【选择车辆】返回空载和满载油耗，则使用车辆的，如果没有，就使用选择的线路的
      if (data) {
        this.otherFormData.lineInfo = data.line;
        // 如果没有使用车辆空载和载重油耗，则使用固定线路的空载和载重油耗
        let emptyOilCostPer = isExist(data.line.emptyOilCostPer) ? (data.line.emptyOilCostPer / 100).toFixed(2) : 0;
        this.otherFormData.oilInfo.emptyOilCostPer = emptyOilCostPer;
        let oilCostPer = isExist(data.line.oilCostPer) ? (data.line.oilCostPer / 100).toFixed(2) : 0;
        this.otherFormData.oilInfo.oilCostPer = oilCostPer;
        if (isExist(this.otherFormData.lineInfo.pontagePer)) {
          this.otherFormData.oilInfo.pontagePer = this.otherFormData.lineInfo.pontagePer;
        }
        this.$refs.assignVehicle.setData({
          oilInfo: this.otherFormData.oilInfo,
          lineInfo: this.otherFormData.lineInfo,
        });
        this.$refs.assignStaff.setData({
          lineInfo: data.line,
        });
        this.$refs.assignFleet.setData({
          lineInfo: data.line,
        });
      }
    },
    // 获取结算信息
    async queryMemberBenefits (options) {
      this.$emit('queryMemberBenefits', options);
    },
    // 搜索结果和归属组件同步
    setBelongForm (data) {
      this.$emit('setBelongForm', data);
    },
    // 设置基本信息
    setVehicleStaffForm (data) {
      this.$refs.assignStaff.setVehicleStaffForm(data);
    },
    isAppointWay (value, appointWay) {
      return `${value}` === `${appointWay}`;
    },
    normalizeAppointWay (appointWay) {
      if (appointWay !== null && appointWay !== undefined && appointWay !== '') {
        return `${appointWay}`;
      }
      const firstOption = this.baseForm.appointWayOptions[0] || {};
      return firstOption.value !== null && firstOption.value !== undefined ? `${firstOption.value}` : '3';
    },
    // 选择调度方式
    async appointWayChange (data = {}) {
      const appointWay = this.normalizeAppointWay(data.appointWay);
      if (!data.fromUserChange && `${this.$refs.baseForm.getVal('appointWay')}` !== `${appointWay}`) {
        this.$refs.baseForm.setVal('appointWay', appointWay);
      }
      if (appointWay === '5') {
        this.$nextTick(() => {
          const assignFleet = this.$refs.assignFleet;
          const contract = assignFleet && assignFleet.$refs && assignFleet.$refs.contract;
          contract && contract.getVehicleClassLevel(3, 'setVehicleInfo');
          this.$emit('queryMemberBenefits', {
            carUserType: 3,
            isChange: true,
          });
        });
      }
      this.$emit('appointWayChange', appointWay);
    },
    async handleSubData (cache) {
      let formData = null;
      let assignVehicleFormData = null;
      let assignStaffFormData = null;
      let assignFleetFormData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
        if (this.$refs.assignVehicle) {
          assignVehicleFormData = await this.$refs.assignVehicle.cacheData();
        }
        if (this.$refs.assignStaff) {
          assignStaffFormData = await this.$refs.assignStaff.cacheData();
        }
        if (this.$refs.assignFleet) {
          assignFleetFormData = await this.$refs.assignFleet.cacheData();
        }
      } else {
        formData = await this.$refs.baseForm.sub();
        const appointWay = this.normalizeAppointWay(formData.appointWay);
        formData.appointWay = appointWay;
        if (appointWay === '3') {
          assignVehicleFormData = await this.$refs.assignVehicle.sub();
          if (assignVehicleFormData === null || assignVehicleFormData === undefined) {
            formData = null;
          }
        } else if (appointWay === '4') {
          assignStaffFormData = await this.$refs.assignStaff.sub();
        } else if (appointWay === '5') {
          assignFleetFormData = await this.$refs.assignFleet.sub();
        }
      }
      if (formData || cache) {
        formData = {
          ...formData,
          ...assignVehicleFormData,
          ...assignStaffFormData,
          ...assignFleetFormData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        let dispatchInfo = {};
        for (let name in formData) {
          if (formData[name] !== null && formData[name] !== undefined) {
            dispatchInfo['dispatchInfo.' + name] = formData[name];
            // 重命名提交的字段名
            renamePostParams(dispatchInfo, formData, name);
          }
        }
        dispatchInfo.updateType = dispatchInfo['dispatchInfo.updateType'];
        // 删除多余的字段
        deleteUnwantParams(dispatchInfo);
        formData = dispatchInfo;
      }
      console.log('参数提交', formData);
      return formData;
    },
    // 设置从详情接口获取的值
    setDetailData (data) {
      adjustData(data);
    },
    // 调整需要提交的 updateType 和 dispatch 参数
    adjustUpdateTypeAndDispatch (data) {
      if (this.$route.query.copy) {
        // 复制订单
        data.updateType = '0';
      } else if (this.$route.query.id) {
        // 修改订单
        data.oldUpdateType = data.updateType;

        if (isExist(data.updateType) && (data.orderInfo.orderState >= 7)) {
          data.updateType = `${data.updateType}`;
        } else if (data.orderInfo.orderState >= 1 && data.orderInfo.orderState <= 4) {
          data.updateType = '1';
        } else if (data.orderInfo.orderState < 7 && data.updateType >= 3) {
          data.updateType = '5';
        } else if (!isExist(data.updateType)) {
          data.updateType = '0';
        }

        // 调度
        if (data.oldUpdateType !== null && data.oldUpdateType > 0 && data.orderInfo.orderState < 7) {
          data.dispatch = '1';
        }

      } else {
        // 新增
        data.updateType = null;
      }
    },
    setEditStatus () {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: !!this.$route.query.id,
        names: ['appointWay'],
      });
    },
    init (data = {}) {
      this.$refs.baseForm.reset();
      this.setDetailData(data);
      // 调整需要提交的 updateType 和 dispatch 参数
      this.adjustUpdateTypeAndDispatch(data);
      this.$refs.baseForm.setVal(data);
      this.setFormValFromData(this.otherFormData, data);
      this.appointWayChange(data);
      // this.isNeedBillChange(data);
      // 重置选择自有车之后的操作
      this.$refs.assignVehicle.resetMyVehicleForm();
      this.$refs.assignVehicle.setCacheAndDetailData(data);
      this.$refs.assignStaff.setCacheAndDetailData(data);
      this.$refs.assignFleet.setCacheAndDetailData(data);
      // this.setEditStatus();
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
